import { render, staticRenderFns } from "./Form8ProcessHeader.vue?vue&type=template&id=20ac27ce&scoped=true"
import script from "./Form8ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form8ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form8ProcessHeader.vue?vue&type=style&index=0&id=20ac27ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac27ce",
  null
  
)

export default component.exports